module.exports = require("./fr-TD.d.ts");